import { loadUIConfig } from "@digatex/digatex-ui-lib"
import ProjectUIConfig from "./config/ui-config.json"

const { dummy: useRuntimeUiConfig, ...staticUiConfig } = ProjectUIConfig

export const UI_CONFIG = useRuntimeUiConfig ? loadUIConfig() : {...loadUIConfig(), ...staticUiConfig}
export const API_URL = process.env.REACT_APP_API_URL
